import { render, staticRenderFns } from "./TypeSelector.vue?vue&type=template&id=daf54c8c&scoped=true"
import script from "./TypeSelector.vue?vue&type=script&lang=js"
export * from "./TypeSelector.vue?vue&type=script&lang=js"
import style0 from "./TypeSelector.vue?vue&type=style&index=0&id=daf54c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf54c8c",
  null
  
)

export default component.exports